import { useTranslation } from 'react-i18next'

import { useOutboundUuid } from '../../../../../hooks'
import {
  ProfileUsersWidgetItem,
  useWidgetContext,
  WidgetContentItemsList,
} from '../../../../Widget'
import { RequestProfileWidgetSideWorkersForm } from '../RequestProfileWidgetSideWorkersForm'

import * as styles from './RequestProfileWidgetSideWorkersContent.module.css'

function RequestProfileWidgetSideWorkersContent({
  initialValues,
  modal,
  requestId,
  sideWorkers,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  const outboundUuid = useOutboundUuid()

  function handleClose() {
    handleDisableEditMode()
    onClose?.()
  }

  function handleSuccess() {
    handleDisableEditMode()
  }

  return isEditMode ? (
    <RequestProfileWidgetSideWorkersForm
      initialValues={initialValues}
      modal={modal}
      requestId={requestId}
      onClose={handleClose}
      onSubmit={onSubmit}
      onSuccess={handleSuccess}
    />
  ) : sideWorkers.length > 0 ? (
    <WidgetContentItemsList
      Item={ProfileUsersWidgetItem}
      itemProps={{ blocked: Boolean(outboundUuid) }}
      items={sideWorkers}
      title={t('RequestProfile.ProvidersSideWorkersTitleKey', {
        count: sideWorkers.length,
      })}
      titleWrapperClassName={styles.itemsListTitleWrapper}
    />
  ) : null
}

export default RequestProfileWidgetSideWorkersContent
